import React from 'react';
import './Policy.css';

export default function ShippingPolicy() {
  return (
    <div className="policy-page container">
      <h1>Shipping Policy</h1>
      <div className="policy-content">
        <p>Last updated: May 06, 2026</p>
        <section>
          <h2>1. Shipping Times</h2>
          <p>We strive to deliver your orders as quickly as possible. Most orders are processed within 24-48 hours. Estimated delivery times are:</p>
          <ul>
            <li>Metro Cities: 3-5 business days</li>
            <li>Other Cities: 5-7 business days</li>
            <li>Remote Areas: 7-10 business days</li>
          </ul>
        </section>
        <section>
          <h2>2. Shipping Costs</h2>
          <p>We offer FREE shipping on all orders above ₹599. For orders below this amount, a flat shipping fee of ₹50 will be charged.</p>
        </section>
        <section>
          <h2>3. Tracking</h2>
          <p>Once your order is shipped, you will receive an email and SMS with the tracking details. You can also track your order on our website using the 'Track Order' page.</p>
        </section>
      </div>
    </div>
  );
}
